import { render, staticRenderFns } from "./PaxUpdate.vue?vue&type=template&id=43e878c8&"
import script from "./PaxUpdate.vue?vue&type=script&lang=js&"
export * from "./PaxUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports